import React, { useEffect } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./App.css";
import { Provider } from "react-redux";
import { Store } from "./store";
import ThemeWrapper from "./theme/theme";
import MoveServices from "./pages/movingServices/MoveServices";
import LabourAndPacking from "./pages/labourAndPacking/LabourAndPacking";
import Dashboard from "./dashboard/Dashboard";
import RegisterCarrier from "./dashboard/RegisterCarrier";
import LoginCarrier from "./dashboard/LoginCarrier";
import ProtectedRoute from "./protected-routes/ProtectedRoute";
import MainScreen from "./components/mainScreen/MainScreen";
import Storage from "./components/storage/Storage";
import BookedMoveInfo from "./components/bookedMoveInfo/BookedMoveInfo";
import NotFound from "./pages/not-found/NotFound";
import MoveSummary from "./components/moveSummary/MoveSummary";
import JunkRemoval from "./pages/junkRemoval/JunkRemoval";
import ConsumerDashboard from "./consumerDashboard/ConsumerDashboard";
import ConsumerLogin from "./components/consumerLogin/ConsumerLogin";
import OtpVerification from "./components/otpVerification/OtpVerification";
import Pricing from "./components/pricing/Pricing";
import Packing from "./components/packing/Packing";
import ChooseService from "./components/chooseService/ChooseService";
import DeliveryDetails from "./components/deliveryDetails/DeliveyDetails";
import ApartmentInfo from "./components/apartmentInfo/ApartmentInfo";
import MovingItems from "./components/movingItems/MovingItems";
import Insurance from "./components/insurance/Insurance";
import UserDetails from "./components/userDetails/UserDetails";
import UploadItems from "./components/uploadItems/UploadItems";
import Inventory from "./components/inventory/Inventory";
import AdminLogin from "./adminDashboard/adminLogin/AdminLogin";
import AdminRegister from "./adminDashboard/adminRegister/AdminRegister";
import AdminDashboard from "./adminDashboard/AdminDashboard";
import SuccessMessage from "./dashboard/inventoryPopulate/successMessage";
import AddInventory from "./dashboard/inventoryPopulate/addInventory";
import AddSupermoveInventory from "./dashboard/supermoveInventory/addSupermoveInventory";
import QrCodePage from "./components/qrCode/qrCode";

function App() {
  // const [initialized, setInitialized] = React.useState(false);
  // useEffect(() => {
  //   if (!initialized) {
  //     // Clear everything
  //     localStorage.clear();
  //     console.log("LocalStorage fully cleared");

  //     // Mark as initialized
  //     setInitialized(true);
  //   }
  // }, [initialized]);
  return (
    <Provider store={Store}>
      <ThemeWrapper>
        <Router>
          <Routes>
            <Route
              path="/:businessName/move-service/:canonicalId"
              element={<MoveServices />}
            />
            <Route
              path="/:businessName/labour-and-packing"
              element={<LabourAndPacking />}
            />
            <Route
              path="/:businessName/labour-and-packing/:canonicalId"
              element={<LabourAndPacking />}
            />
            <Route
              path="/:businessName/dashboard"
              element={
                <ProtectedRoute allowedRoles={["carrier"]}>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route path="/register-carrier" element={<RegisterCarrier />} />
            <Route path="/login-carrier" element={<LoginCarrier />} />
            <Route
              path="/:businessName/:carrierCanonicalId/select-service"
              element={<MainScreen />}
            />
            <Route
              path="/:businessName/move-service"
              element={<MoveServices />}
            />
            <Route
              path="/:businessName/:carrierCanonicalId/move-success/:canonicalId"
              element={<BookedMoveInfo />}
            />
            <Route path="/not-found" element={<NotFound />} />
            <Route
              path="/:businessName/junk-removal"
              element={<JunkRemoval />}
            />
            <Route
              path="/:businessName/junk-removal/:canonicalId"
              element={<JunkRemoval />}
            />
            <Route
              path="/:businessName/:carrierCanonicalId/packaging/:canonicalId"
              element={<Packing />}
            />
            <Route
              path="/:businessName/:carrierCanonicalId/consumer-dashboard/:canonicalId"
              element={<ConsumerDashboard />}
            />
            <Route
              path="/:businessName/:carrierCanonicalId/consumer-login"
              element={<ConsumerLogin />}
            />
            <Route
              path="/:businessName/:carrierCanonicalId/otp-verification"
              element={<OtpVerification />}
            />
            {/* <Route
              path="/:businessName/choose-service/:canonicalId"
              element={<ChooseService serviceType="move-service"/>}
            /> */}
            <Route
              path="/:businessName/:carrierCanonicalId/choose-service"
              element={<ChooseService serviceType="move-service" />}
            />
            <Route
              path="/:businessName/:carrierCanonicalId/delivery-details/:canonicalId"
              element={<DeliveryDetails />}
            />
            <Route
              path="/:businessName/:carrierCanonicalId/apartment-info/:canonicalId"
              element={<ApartmentInfo />}
            />
            <Route
              path="/:businessName/:carrierCanonicalId/bulky-items/:canonicalId"
              element={<MovingItems />}
            />
            <Route
              path="/:businessName/:carrierCanonicalId/insurance/:canonicalId"
              element={<Insurance />}
            />
            <Route
              path="/:businessName/:carrierCanonicalId/user-details/:canonicalId"
              element={<UserDetails currentValues="move_service" />}
            />
            <Route
              path="/:businessName/:carrierCanonicalId/storage/:canonicalId"
              element={<Storage />}
            />
            <Route
              path="/:businessName/:carrierCanonicalId/upload-items/:canonicalId/:sessionNumber?"
              element={<UploadItems />}
            />
            <Route
              path="/:businessName/:carrierCanonicalId/inventory/:canonicalId"
              element={<Inventory />}
            />
            <Route
              path="/:businessName/:carrierCanonicalId/guidelines/:canonicalId"
              element={<QrCodePage />}
            />
            <Route
              path="/:businessName/:carrierCanonicalId/move-price/:canonicalId"
              element={<Pricing />}
            />
            <Route
              path="/:businessName/:carrierCanonicalId/move-summary/:canonicalId"
              element={<MoveSummary />}
            />
            <Route path="/admin-login" element={<AdminLogin />} />
            {/* <Route path="/admin-register" element={<AdminRegister />} /> */}
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
            <Route
              path="/:businessName/add-inventory/:phoneNumber"
              element={<AddInventory />}
            />
            <Route
              path="/supermove-images/add-supermove-inventory/:phoneNumber/:identifier"
              element={<AddSupermoveInventory />}
            />
            <Route
              path="/:businessName/success-message"
              element={<SuccessMessage />}
            />
          </Routes>
        </Router>
      </ThemeWrapper>
    </Provider>
  );
}

export default App;
